import React from "react";
import Block from "../Block";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { spacingClassName, spacingProps } from "../props/spacing";
import { colorPropTypes, sxClassName, sxProps, textAlignPropTypes } from "../props/sx";
import { utilityClassName, utilityProps } from "../props/utility";

const HeroDescription = ({
	align,
	color = "",
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	className = "",
	...props
}) => {
	return (
		<Block
			className={classes(
				"section-hero__description",
				...utilityClassName(utility),
				...sxClassName(deepMergeProps({ fontColor: color, textAlign: align }, pureProps(sx))),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		/>
	);
};

HeroDescription.propTypes = {
	align: textAlignPropTypes,
	color: colorPropTypes,
	...Block.propTypes,
};

export default HeroDescription;
